var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIconCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3639_92158)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3332 7.33268C19.852 7.33268 21.0832 8.5639 21.0832 10.0827V18.3327C21.0832 19.8515 19.852 21.0827 18.3332 21.0827H10.0832C8.56439 21.0827 7.33317 19.8515 7.33317 18.3327V10.0827C7.33317 8.5639 8.56439 7.33268 10.0832 7.33268H18.3332ZM18.3332 9.16602H10.0832C9.57691 9.16602 9.1665 9.57642 9.1665 10.0827V18.3327C9.1665 18.8389 9.57691 19.2493 10.0832 19.2493H18.3332C18.8394 19.2493 19.2498 18.8389 19.2498 18.3327V10.0827C19.2498 9.57642 18.8394 9.16602 18.3332 9.16602ZM11.9165 0.916016C13.381 0.916016 14.5782 2.06086 14.6618 3.50443L14.6665 3.66602V4.58268C14.6665 5.08894 14.2561 5.49935 13.7498 5.49935C13.2797 5.49935 12.8923 5.14548 12.8393 4.68959L12.8332 4.58268V3.66602C12.8332 3.19592 12.4793 2.80847 12.0234 2.75552L11.9165 2.74935H3.6665C3.1964 2.74935 2.80896 3.10322 2.756 3.55911L2.74984 3.66602V11.916C2.74984 12.3861 3.10371 12.7736 3.5596 12.8265L3.6665 12.8327H4.58317C5.08943 12.8327 5.49984 13.2431 5.49984 13.7493C5.49984 14.2194 5.14597 14.6069 4.69007 14.6599L4.58317 14.666H3.6665C2.20196 14.666 1.00481 13.5212 0.921172 12.0776L0.916504 11.916V3.66602C0.916504 2.20147 2.06135 1.00433 3.50492 0.920684L3.6665 0.916016H11.9165Z",
    fill: "#222729"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3639_92158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconCopy);
export default __webpack_public_path__ + "static/media/profile-icon-copy.d2af6f193c7b839bb91f28a6722ff767.svg";
export { ForwardRef as ReactComponent };